import { Role, User } from '@ekkogmbh/apisdk';
import CoordinateListItem from 'src/Common/Components/CoordinateListItem';
import PaginatedSelect from 'src/Common/Components/Forms/PaginatedSelect';
import useEkko from 'src/Common/Providers/EkkoProvider';

interface Props {
  role?: Role;
  user?: User;
  onChange: (role?: Role) => void;
  disabled?: boolean;
}

export default function RolePicker({ role, disabled, onChange }: Props): React.JSX.Element {
  const { api } = useEkko();

  return (
    <PaginatedSelect
      label={'Role'}
      value={role}
      disabled={disabled}
      onChange={(r) => onChange(r as Role | undefined)}
      itemId={(r) => r.name}
      itemRender={(r) => <CoordinateListItem label={r.name} coordinate={r.coordinate} />}
      fetchPaginatedItems={async (pagination) => api.getRoles(pagination)}
    />
  );
}
